export const SEARCH_BICYCLE = {
  method: 'GET',
  route: '/search-bicycles',
};
